<template>
  <div class="ba-site-header-wrapper">
  <div class="ba-site-logo-wrapper">
    <div class="ba-site-logo">
      <router-link to="/">
        <svg viewBox="0 0 1000 204"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Logo Baloise</title>
          <defs>
            <path id="a" d="M.44.418h4.998V7.11H.441z"/>
            <path id="c" d="M0 46.533h180.319V1.087H0z"/>
          </defs>
          <path xmlns="http://www.w3.org/2000/svg" fill="#000d6e" d="M307.71 57.5c-12.43 0-22.9 3.7-31.18 10.68V15.63h-36.42V175h33.58v-9.82c8.29 8.07 19.41 12.65 33.15 12.65 33.36 0 57.13-25.73 57.13-60.19S340.86 57.5 307.71 57.5zm-6.1 88.31c-15.92 0-26.83-11.55-26.83-28.13 0-16.79 10.69-28.34 26.83-28.34 15.26 0 26.38 12 26.38 28.34s-11.12 28.13-26.38 28.13zm164.85-73.7c-8.07-8.07-19-12.43-33.14-12.43-33.37 0-57.36 23.55-57.36 58s24 60.19 57.36 60.19c14.17 0 25.07-4.8 33.14-13.3V175h33.59V60.11h-33.59zm-27.91 73.7c-15.48 0-26.39-11.77-26.39-28.13s11.13-28.34 26.39-28.34c15.92 0 26.6 11.55 26.6 28.34 0 16.58-10.68 28.13-26.6 28.13zM524.06 175h36.42V15.63h-36.42zM639.22 57.5c-36.63 0-62.8 25.73-62.8 60.18 0 34.24 26.17 60.19 62.8 60.19 36.86 0 63-26 63-60.19.03-34.45-26.14-60.18-63-60.18zm.22 88.1c-15.92 0-26.39-11.78-26.39-27.92 0-16.57 10.47-27.91 26.39-27.91s26.17 11.34 26.17 27.7c0 16.53-10.47 28.13-26.17 28.13zM736.8 0c-12.87 0-23.91 9.38-23.91 22.46s11 22.24 23.91 22.24 22.89-9.15 22.89-22.24S749.66 0 736.8 0zm-18.32 175h36.42V60.11h-36.42zm92-83.52c0-4.8 3.71-7.64 11.12-7.64 7.63 0 13.09 3.71 15.7 10.91L867.42 83c-4.58-16.14-21.59-25.51-45.14-25.51C793.27 57.5 775 71 775 93.26c0 39.47 60 30.75 60 48.85 0 5.23-4.36 8.5-12.64 8.5-11.78 0-19.41-5.45-22.46-15l-30.1 11.55c6.76 20.07 25.3 30.75 51.25 30.75 30.31 0 49.5-14.39 49.5-38.16-.08-42.35-60.05-31.88-60.05-48.23zM1000 115.29c0-28.35-22.24-58-59.75-58-33.15 0-59.75 27.26-59.75 60.4 0 34.24 24 60.19 61.93 60.19 25 0 39.83-9.65 48.7-20.65l-20.94-21c-6.54 8.1-13.8 12-26.67 12-13.74 0-24-7-27.7-19.84h83.31a93 93 0 0 0 .87-13.1zm-84.61-9.6c3.05-14 12.43-21.15 25.73-21.15s22 8.07 25.08 21.15zM2.52 97.92a8.59 8.59 0 0 0 0 12.16l91.4 91.4a8.59 8.59 0 0 0 12.16 0l50.72-50.72-30.87-30.87L100 145.81 58.19 104 100 62.19l72.69 72.68 24.79-24.79a8.59 8.59 0 0 0 0-12.16l-91.4-91.4a8.59 8.59 0 0 0-12.16 0z"/>
        </svg>           
      </router-link>
    </div>
    <div class="ba-site-lang-switch">
      <router-link :to="'/' + this.userType +'/nl'+ this.currentPath" class="ba-site-lang-switch__item">NL</router-link>
      <router-link :to="'/' + this.userType +'/fr' + this.currentPath" class="ba-site-lang-switch__item">FR</router-link>
      <router-link :to="'/' + this.userType +'/en' + this.currentPath" class="ba-site-lang-switch__item">EN</router-link>
      <template v-if="user">
        <span class="ba-site-lang-switch__item">{{$t('authentication.loggedInAs')}} {{user.emailAddress}}</span>
        <a href="#" class="ba-site-lang-switch__item" @click.prevent="signOut()">{{$t('authentication.logOut')}}</a>
      </template>
      <template v-else>
        <router-link :to="'/'" class="ba-site-lang-switch__item">{{$t('authentication.logIn')}}</router-link>
      </template>
    </div>
    </div>
    <div class="ba-site-header">
      <div class="ba-site-header__top">
        <div class="ba-site-title">
          <div class="ba-site-title-wrapper">
            <div>
              <h1 class="ba-site-title__title">{{ $t('simulationHeader.title') }}</h1>
              <h2 class="ba-site-title__subtitle">{{ subtitle }}</h2>
            </div>
          </div>
        </div>
        <div v-if="search" class="ba-simulation-header__search ba-simulation-header__title-search">
          <form @submit.prevent="searchContract">
            <input
              class="ba-simulation-header__search-input ba-input-field"
              id="searchContract"
              type="text"
              v-model="searchValue"
              :placeholder="$t('search.searchPolis.placeholder')"
            />
            <button
              type="submit"
              @click="searchContract"
              class="ba-simulation-header__search-submit"
            >
              <font-awesome-icon icon="search" aria-hidden="true" />
              <span class="ba-simulation-header__search-submit__label">
                {{ $t('search.searchPolis.submit') }}
              </span>
            </button>
          </form>
        </div>
        <div v-if="closeable" class="ba-simulation-header__close">
          <ba-button icon="times" mod-dark @click="close"></ba-button>
        </div>
      </div>
      <div class="ba-header-versions">
      <ba-tab :mod-active="v2021" :to="URI_v2021">
         {{ $t('generic.controle2021')}}
      </ba-tab>
      <ba-tab :mod-active="v2022" :to="URI_v2022">
         {{ $t('generic.controle2022')}}
      </ba-tab>
      <ba-tab :mod-active="!v2021 && !v2022" :to="URI_v">
         {{ $t('generic.controle')}} {{ currentYear }}
      </ba-tab>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { BaButton } from '@/components/atoms/ba-button/vue/';
import { BaTab } from '@/components/atoms/ba-tab/vue/';
import i18n from '@/plugins/i18n';
import moment from 'moment';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/oidc/oidcUser',
    }),
    currentPath() {
      return this.$route.path.substring(this.userType.length + 4);
    },
    userType() {
      if (this.user && this.user.UserType) {
        if (Array.isArray(this.user.UserType)) {
          return this.user.UserType[0].toLowerCase();
        }
        return this.user.UserType.toLowerCase();
      }
      return 'internal';
    },
    currentYear() {
      return moment().year();
    },
    v2021() {
      return process.env.VUE_APP_VERSION === '2021';
    },
    v2022() {
      return process.env.VUE_APP_VERSION === '2022';
    },
    URI_v2021() {
      return process.env.VUE_APP_URI_2021 + this.userType;
    },
    URI_v2022() {
      console.log(process.env.VUE_APP_URI_2022);
      return process.env.VUE_APP_URI_2022 + this.userType;
    },
    URI_v() {
      return process.env.VUE_APP_URI + this.userType;
    },
  },
  data() {
    return {
      searchValue: '',
    };
  },
  components: {
    BaButton,
    BaTab,
  },
  props: {
    subtitle: String,
    search: {
      type: Boolean,
      default: false,
    },
    closeable: Boolean,
  },
  methods: {
    ...mapActions({
      signOut: 'auth/oidc/signOutOidc',
    }),
    searchContract() {
      this.$store.dispatch('search/searchContracts', this.searchValue);
      this.$router.push(`/${this.userType}/${i18n.locale}/search`);
    },
    close() {
      if (window.history.length <= 1) {
        window.close();
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
